import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "redux/reducers";
import { setFilters } from "redux/actions/catalog";

import Spinner from "components/Common/misc/Spinner";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";

import CatalogSkeleton from "./CatalogSkeleton";
import { medskuFilters, medskuMenu } from "data/menus/catalogMenu";

import { generatePageTitle } from "utils/general.utils";
import { fetchMedSKUCatalogData, resetFilters } from "redux/actions/medsku";
import { useAuth } from "contexts/AuthContext";
import { fetchMedSKUSubscriptions } from "redux/actions/subscriptions";

const MedSKUList = React.lazy(
  () => import("./ChildComponents/Preview/MedSKUList")
);

const MedSKU = () => {
  const { currentUser } = useAuth();
  const dispatch = useDispatch();
  const location = useLocation();
  const { medsku } = useSelector((state: RootState) => state);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    dispatch(fetchMedSKUCatalogData(setLoading));
    
    if (currentUser.email !== "support@idataresearch.net" &&
        currentUser.email !== "marketing@idataresearch.net") {
      dispatch(fetchMedSKUSubscriptions(currentUser.usergroupData.id));
    }
  }, []);

  useEffect(() => {
    dispatch(resetFilters());
  }, [medsku.filters.filter, medsku.categories.length, dispatch]);

  // Change filter based on pathname
  useEffect(() => {
    switch (location.pathname) {
      case "/medsku/subscriptions":
        dispatch(setFilters("filter", "Subscriptions"));
        dispatch(setFilters("subscribed", true));
        document.title = generatePageTitle("Subscriptions");
        break;
      case "/medsku/favorites":
        dispatch(setFilters("filter", "Favorites"));
        dispatch(setFilters("subscribed", false));
        document.title = generatePageTitle("Favorites");
        break;
      default:
        dispatch(setFilters("filter", "All MedSKU"));
        dispatch(setFilters("subscribed", false));
        document.title = generatePageTitle("All MedSKU");
        break;
    }
  }, [dispatch, location.pathname]);

  if (loading) {
    return (
      <>
        <Header />
        <Spinner />
        <Footer />
      </>
    );
  } else {
    return (
      <>
        <Header />
        <Container>
          <CatalogSkeleton
            menu={medskuMenu}
            filters={medskuFilters}
            list={<MedSKUList />}
            hideFilters={false}
            parent={"medsku"}
            sectionName={"MedSKU Catalog"}
          />
        </Container>
        <Footer />
      </>
    );
  }
};

const Container = styled.div`
  background-color: #f6f8f9;
  color: #000;
  /* min-height: 100vh; */
  overflow-y: auto;
  width: 100%;
`;

export default MedSKU;
